
export { HorizontalProductCardSkeleton } from "/codebuild/output/src2340768698/src/packages/shared-components/src/components/ProductCard/index.ts"
export { VerticalProductCardSkeleton } from "/codebuild/output/src2340768698/src/packages/shared-components/src/components/ProductCard/index.ts"